import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { AppContext, AppContextType } from '../context/AppContext';
import EntireLoadingPage from 'components/ui/EntireLoadingPage';

// TODO If at some point we're creating a landing page for teamStation. Replace this file and create a proper page for it
const InitialPage = (): JSX.Element => {
    const navigate = useNavigate();
    const { isLoggedIn } = React.useContext(AppContext) as AppContextType;
    React.useEffect(() => {
        // TODO Change the initial page if needed
        navigate(isLoggedIn ? 'tasks' : 'login', { replace: !isLoggedIn });
    }, [navigate, isLoggedIn]);

    return <EntireLoadingPage />;
};

export default InitialPage;
